
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residences/[residence]",
      function () {
        return require("private-next-pages/residences/[residence].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residences/[residence]"])
      });
    }
  